import CancelIcon from '@mui/icons-material/Cancel';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';

import { ICampaign, ICampaignSummary } from '../../../types/campaigns';
import { IResultPriceWithCurrency } from '../../../types/shell';
import { Price } from '../../index';

import variables from '../../../contexts/ThemeProvider/variables';

interface IProps {
  campaign: ICampaignSummary;
  total: IResultPriceWithCurrency;
  onRemove?: (boxId: string) => void;
  onClick?: (campaign: ICampaign) => void;
  isDisabled?: boolean;
}

export const CampaignListItem: React.FC<IProps> = ({ campaign, onClick, total, onRemove }) => {
  const { box_id, icon_url, name } = campaign;
  return (
    <Box
      key={box_id}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 1,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        width: '100%',
      }}
      onClick={() => campaign && onClick?.(campaign as ICampaign)}
      role="button"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 2,
          marginY: 1,
        }}
      >
        {icon_url && (
          <Box
            component="img"
            src={icon_url}
            alt={name}
            sx={{ width: 70, height: 64, borderRadius: 1, padding: 1, border: `1px solid #E5E7F0` }}
          />
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Price value={total} />
          <Typography variant="subtitle1">{name}</Typography>
        </Box>
      </Box>
      {onRemove && (
        <IconButton onClick={() => onRemove(box_id)}>
          <CancelIcon sx={{ fontSize: 16, color: variables.errorRed }} />
        </IconButton>
      )}
    </Box>
  );
};
